import React, { useEffect, useMemo, useState } from 'react';
import { CnInput } from '../components/CnInput';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';
import { ROLES } from '../utils/config';

const getType = (u) => {
  if (u.role === 'owner') {
    return u.account_type === 'tenant' ? 'tenant' : 'owner';
  }
  return 'staff';
};

const typeText = (u) => {
  const t = getType(u);
  if (t === 'owner') return '业主';
  if (t === 'tenant') return '租户';
  return ROLES[u.role] || '员工';
};

export default function UserManage() {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tab, setTab] = useState('all');
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('all');

  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [detailUser, setDetailUser] = useState(null);

  const [form, setForm] = useState({
    username:'',
    password:'',
    real_name:'',
    role:'steward',
    account_type:'',
    room_no:'',
    phone:'',
    is_active:1
  });

  const fetchUsers = async () => {
    try {
      const res = await API.get('/users');
      setUsers(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      alert('获取账号失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const counts = useMemo(() => ({
    all: users.length,
    owner: users.filter(u => getType(u) === 'owner').length,
    tenant: users.filter(u => getType(u) === 'tenant').length,
    staff: users.filter(u => getType(u) === 'staff').length
  }), [users]);

  const filteredUsers = useMemo(() => {
    const kw = keyword.trim().toLowerCase();

    return users.filter(u => {
      const t = getType(u);

      if (tab !== 'all' && t !== tab) return false;

      if (status === 'active' && !u.is_active) return false;
      if (status === 'disabled' && u.is_active) return false;

      if (!kw) return true;

      const text = [
        u.real_name,
        u.username,
        u.phone,
        u.room_no,
        u.id_card_no
      ].filter(Boolean).join(' ').toLowerCase();

      return text.includes(kw);
    });
  }, [users, tab, keyword, status]);

  const openAdd = () => {
    setEditUser(null);
    setForm({
      username:'',
      password:'',
      real_name:'',
      role:'steward',
      account_type:'',
      room_no:'',
      phone:'',
      is_active:1
    });
    setShowForm(true);
  };

  const openEdit = (u) => {
    setEditUser(u);
    setForm({
      ...u,
      account_type:
        u.role === 'owner'
          ? (u.account_type ||
            (u.resident_type === '租客' || u.resident_type === '租户'
              ? 'tenant'
              : 'owner'))
          : '',
      password:''
    });
    setShowForm(true);
  };

  const handleSubmit = async () => {
    if (!form.real_name || !form.role) {
      alert('请填写姓名和角色');
      return;
    }

    if (!editUser && (!form.username || !form.password)) {
      alert('请填写账号和密码');
      return;
    }

    if (form.role === 'owner' && !form.room_no) {
      alert('住户账号必须填写房号');
      return;
    }

    if (!editUser &&
        form.role === 'owner' &&
        form.account_type === 'tenant') {
      alert('租户必须从实名注册页面提交身份证照片和本人正脸照片，经物业审核后开通账号');
      return;
    }

    try {
      if (editUser) {
        await API.put(`/users/${editUser.id}`, form);
      } else {
        await API.post('/users', form);
      }

      alert(editUser ? '修改成功' : '创建成功');
      setShowForm(false);
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || '操作失败');
    }
  };


  const [cancellingId,setCancellingId]=useState(null);

  const handleCancelRegistration=async(u)=>{
    if(u.role!=='owner') return;
    const input=window.prompt(
      `注销账号：${u.real_name}\n房号：${u.room_no||'无'}\n`+
      `手机号：${u.phone||'无'}\n\n`+
      `旧账号将停用，手机号将释放。\n`+
      `旧门禁人脸需要另行撤权。\n\n请输入：确认注销`
    );
    if(input!=='确认注销') return;
    try {
      setCancellingId(u.id);
      const response=await API.post(
        `/users/${u.id}/cancel-for-reregistration`,
        {confirm:'确认注销'}
      );
      alert(
        response.data.message+
        '\n注意：旧门禁权限尚未确认撤销，请到门禁管理检查。'
      );
      await fetchUsers();
    } catch(e) {
      alert(e.response?.data?.message||'注销失败');
    } finally {
      setCancellingId(null);
    }
  };

  const handleToggle = async (u) => {
    if (!window.confirm(
      `确定${u.is_active ? '禁用' : '启用'}“${u.real_name}”账号？`
    )) return;

    try {
      await API.put(`/users/${u.id}`, {
        ...u,
        is_active: u.is_active ? 0 : 1
      });
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || '操作失败');
    }
  };

  const tabs = [
    ['all', '全部'],
    ['owner', '业主'],
    ['tenant', '租户'],
    ['staff', '员工']
  ];

  return (
    <div style={s.page}>

      <header style={s.header}>
        <button style={s.back} onClick={() => navigate(-1)}>
          ← 返回
        </button>

        <div style={s.headerCenter}>
          <div style={s.title}>账号管理</div>
          <div style={s.headerSub}>共 {users.length} 个账号</div>
        </div>

        <button style={s.add} onClick={openAdd}>
          ＋新增
        </button>
      </header>

      <main style={s.body}>

        <div style={s.tabs}>
          {tabs.map(([key, label]) => (
            <button
              key={key}
              style={{
                ...s.tab,
                ...(tab === key ? s.tabActive : {})
              }}
              onClick={() => setTab(key)}
            >
              <span>{label}</span>
              <span style={{
                ...s.count,
                ...(tab === key ? s.countActive : {})
              }}>
                {counts[key]}
              </span>
            </button>
          ))}
        </div>

        <div style={s.searchCard}>
          <input
            style={s.search}
            value={keyword}
            onChange={e => setKeyword(e.target.value)}
            placeholder="搜索姓名、手机号、账号、房号、身份证号"
          />

          <div style={s.filterRow}>
            <button
              style={{
                ...s.filterBtn,
                ...(status === 'all' ? s.filterActive : {})
              }}
              onClick={() => setStatus('all')}
            >
              全部状态
            </button>

            <button
              style={{
                ...s.filterBtn,
                ...(status === 'active' ? s.filterActive : {})
              }}
              onClick={() => setStatus('active')}
            >
              正常
            </button>

            <button
              style={{
                ...s.filterBtn,
                ...(status === 'disabled' ? s.filterActive : {})
              }}
              onClick={() => setStatus('disabled')}
            >
              已禁用
            </button>

            <button
              style={s.reviewBtn}
              onClick={() => navigate('/staff-review')}
            >
              员工审核
            </button>
          </div>
        </div>

        <div style={s.resultBar}>
          找到 {filteredUsers.length} 个账号
        </div>

        {loading ? (
          <div style={s.empty}>加载中...</div>
        ) : filteredUsers.length === 0 ? (
          <div style={s.empty}>没有符合条件的账号</div>
        ) : (
          filteredUsers.map(u => {
            const t = getType(u);

            return (
              <div
                key={u.id}
                style={{
                  ...s.card,
                  opacity: u.is_active ? 1 : 0.65
                }}
              >
                <div style={s.cardTop}>
                  <div style={s.nameLine}>
                    <span style={s.name}>
                      {u.real_name || '未填写姓名'}
                    </span>

                    <span style={{
                      ...s.badge,
                      background:
                        !u.is_active
                          ? '#8c8c8c'
                          : t === 'tenant'
                          ? '#7b4ab5'
                          : t === 'owner'
                          ? '#1a4a8a'
                          : '#1677ff'
                    }}>
                      {typeText(u)}
                    </span>

                    <span style={{
                      ...s.statusBadge,
                      ...(u.is_active ? s.statusOk : s.statusOff)
                    }}>
                      {u.is_active ? '正常' : '已禁用'}
                    </span>
                  </div>
                </div>

                {u.room_no && (
                  <div style={s.primaryInfo}>
                    🏠 {u.room_no}
                  </div>
                )}

                <div style={s.info}>
                  📱 {u.phone || '未登记手机号'}
                </div>

                <div style={s.info}>
                  👤 登录账号：{u.username || '—'}
                </div>

                {t === 'tenant' && (
                  <div style={s.verifyRow}>
                    <span style={
                      u.id_card_photo
                        ? s.verifyOk
                        : s.verifyBad
                    }>
                      {u.id_card_photo ? '✓ 身份证' : '⚠ 缺身份证照片'}
                    </span>

                    <span style={
                      u.face_photo
                        ? s.verifyOk
                        : s.verifyBad
                    }>
                      {u.face_photo ? '✓ 人脸' : '⚠ 缺人脸'}
                    </span>
                  </div>
                )}

                <div style={s.actions}>
                  <button
                    style={s.detailBtn}
                    onClick={() => setDetailUser(u)}
                  >
                    查看详情
                  </button>

                  <button
                    style={s.editBtn}
                    onClick={() => openEdit(u)}
                  >
                    编辑
                  </button>

                  <button
                    style={{
                      ...s.toggleBtn,
                      background: u.is_active ? '#fff1f0' : '#f6ffed',
                      color: u.is_active ? '#cf1322' : '#389e0d',
                      borderColor: u.is_active ? '#ffa39e' : '#b7eb8f'
                    }}
                    onClick={() => handleToggle(u)}
                  >
                    {u.is_active ? '禁用' : '启用'}
                  </button>
                  {u.role==='owner' && Number(u.is_active)===1 && (
                    <button
                      type="button"
                      disabled={cancellingId===u.id}
                      onClick={()=>handleCancelRegistration(u)}
                      style={{
                        padding:'9px 12px',
                        border:'1px solid #ff7875',
                        background:'#fff1f0',
                        color:'#cf1322',
                        borderRadius:8,
                        cursor:'pointer'
                      }}
                    >
                      {cancellingId===u.id?'注销中...':'注销并允许重新注册'}
                    </button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </main>

      {detailUser && (
        <div style={s.modal}>
          <div style={s.detailSheet}>

            <div style={s.sheetHead}>
              <div>
                <div style={s.sheetTitle}>
                  {detailUser.real_name}
                </div>
                <div style={s.sheetSub}>
                  {typeText(detailUser)}
                  {' · '}
                  {detailUser.is_active ? '账号正常' : '账号已禁用'}
                </div>
              </div>

              <button
                style={s.close}
                onClick={() => setDetailUser(null)}
              >
                ×
              </button>
            </div>

            <Detail label="登录账号" value={detailUser.username}/>
            <Detail label="姓名" value={detailUser.real_name}/>
            <Detail label="手机号" value={detailUser.phone}/>
            <Detail label="房号" value={detailUser.room_no}/>
            <Detail label="身份" value={typeText(detailUser)}/>

            {getType(detailUser) === 'tenant' && (
              <>
                <div style={s.sectionTitle}>实名认证资料</div>

                <Detail
                  label="身份证号码"
                  value={detailUser.id_card_no || '未登记'}
                />

                <div style={s.photoTitle}>身份证原件</div>

                {detailUser.id_card_photo ? (
                  <a
                    href={`/uploads/${encodeURIComponent(
                      String(detailUser.id_card_photo)
                        .split(/[\\/]/)
                        .pop()
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    style={s.photoLink}
                  >
                    <img
                      src={`/uploads/${encodeURIComponent(
                        String(detailUser.id_card_photo)
                          .split(/[\\/]/)
                          .pop()
                      )}`}
                      alt="身份证原件"
                      style={s.idPhoto}
                    />
                    <div style={s.openText}>
                      点击查看身份证原图
                    </div>
                  </a>
                ) : (
                  <div style={s.missing}>
                    未保存身份证照片
                  </div>
                )}

                <div style={s.photoTitle}>本人正脸照片</div>

                {detailUser.face_photo ? (
                  <a
                    href={`/uploads/${encodeURIComponent(
                      String(detailUser.face_photo)
                        .split(/[\\/]/)
                        .pop()
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    style={s.photoLink}
                  >
                    <img
                      src={`/uploads/${encodeURIComponent(
                        String(detailUser.face_photo)
                          .split(/[\\/]/)
                          .pop()
                      )}`}
                      alt="本人正脸"
                      style={s.facePhoto}
                    />
                    <div style={s.openText}>
                      点击查看人脸原图
                    </div>
                  </a>
                ) : (
                  <div style={s.missing}>
                    未保存人脸照片
                  </div>
                )}
              </>
            )}

            <button
              style={s.sheetEdit}
              onClick={() => {
                const u = detailUser;
                setDetailUser(null);
                openEdit(u);
              }}
            >
              编辑账号资料
            </button>

          </div>
        </div>
      )}

      {showForm && (
        <div style={s.modal}>
          <div style={s.formSheet}>

            <div style={s.sheetHead}>
              <div style={s.sheetTitle}>
                {editUser ? '编辑账号' : '新增账号'}
              </div>

              <button
                style={s.close}
                onClick={() => setShowForm(false)}
              >
                ×
              </button>
            </div>

            <CnInput
              style={s.input}
              placeholder="真实姓名 *"
              value={form.real_name}
              onChange={v => setForm({...form, real_name:v})}
            />

            {!editUser && (
              <input
                style={s.input}
                placeholder="登录账号 *"
                value={form.username}
                onChange={e =>
                  setForm({...form, username:e.target.value})
                }
              />
            )}

            <CnInput
              style={s.input}
              placeholder={
                editUser
                  ? '新密码（不改则留空）'
                  : '登录密码 *'
              }
              type="password"
              value={form.password}
              onChange={v => setForm({...form, password:v})}
            />

            <select
              style={s.input}
              value={form.role}
              onChange={e => {
                const role = e.target.value;
                setForm({
                  ...form,
                  role,
                  account_type:
                    role === 'owner'
                      ? (form.account_type || 'owner')
                      : ''
                });
              }}
            >
              {Object.entries(ROLES).map(([k,v]) => (
                <option key={k} value={k}>
                  {v}
                </option>
              ))}
            </select>

            {form.role === 'owner' && (
              <>
                <div style={s.fieldLabel}>账户类型</div>

                <select
                  style={s.input}
                  value={form.account_type || 'owner'}
                  onChange={e =>
                    setForm({
                      ...form,
                      account_type:e.target.value
                    })
                  }
                >
                  <option value="owner">业主</option>
                  <option value="tenant" disabled={!editUser}>
                    租户{!editUser ? '（请走实名注册）' : ''}
                  </option>
                </select>

                <div style={s.tip}>
                  租户必须通过实名注册提交身份证和本人正脸照片，
                  经物业审核后开通。
                </div>

                <input
                  style={s.input}
                  placeholder="房号（住户必填）"
                  value={form.room_no}
                  onChange={e =>
                    setForm({...form, room_no:e.target.value})
                  }
                />
              </>
            )}

            <CnInput
              style={s.input}
              placeholder="手机号"
              value={form.phone}
              onChange={v => setForm({...form, phone:v})}
            />

            <div style={s.modalBtns}>
              <button
                style={s.cancel}
                onClick={() => setShowForm(false)}
              >
                取消
              </button>

              <button
                style={s.confirm}
                onClick={handleSubmit}
              >
                确认保存
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}

function Detail({label, value}) {
  return (
    <div style={s.detailRow}>
      <div style={s.detailLabel}>{label}</div>
      <div style={s.detailValue}>{value || '—'}</div>
    </div>
  );
}

const s = {
  page:{
    minHeight:'100vh',
    background:'#f5f7fa',
    paddingBottom:70
  },

  header:{
    height:64,
    boxSizing:'border-box',
    background:'linear-gradient(90deg,#174a87,#2878c7)',
    display:'flex',
    alignItems:'center',
    padding:'8px 14px',
    position:'sticky',
    top:0,
    zIndex:100,
    boxShadow:'0 2px 8px rgba(0,0,0,.12)'
  },

  back:{
    width:72,
    border:0,
    background:'transparent',
    color:'#fff',
    fontSize:15,
    textAlign:'left'
  },

  headerCenter:{
    flex:1,
    textAlign:'center'
  },

  title:{
    color:'#fff',
    fontSize:19,
    fontWeight:800
  },

  headerSub:{
    color:'rgba(255,255,255,.75)',
    fontSize:11,
    marginTop:2
  },

  add:{
    width:72,
    height:38,
    border:0,
    borderRadius:20,
    background:'#fff',
    color:'#174a87',
    fontSize:14,
    fontWeight:800
  },

  body:{
    maxWidth:760,
    margin:'0 auto',
    padding:'12px'
  },

  tabs:{
    display:'grid',
    gridTemplateColumns:'repeat(4,1fr)',
    background:'#fff',
    borderRadius:13,
    padding:5,
    gap:3,
    boxShadow:'0 2px 8px rgba(0,0,0,.05)'
  },

  tab:{
    border:0,
    background:'transparent',
    padding:'10px 2px',
    borderRadius:9,
    fontSize:14,
    color:'#666',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    gap:4
  },

  tabActive:{
    background:'#eaf3ff',
    color:'#174a87',
    fontWeight:800
  },

  count:{
    fontSize:10,
    background:'#eee',
    borderRadius:10,
    padding:'1px 5px'
  },

  countActive:{
    background:'#174a87',
    color:'#fff'
  },

  searchCard:{
    marginTop:10,
    background:'#fff',
    padding:10,
    borderRadius:13,
    boxShadow:'0 2px 8px rgba(0,0,0,.05)'
  },

  search:{
    width:'100%',
    height:42,
    border:'1px solid #e2e5e9',
    borderRadius:9,
    padding:'0 12px',
    boxSizing:'border-box',
    fontSize:14,
    outline:'none'
  },

  filterRow:{
    display:'flex',
    gap:6,
    marginTop:8,
    overflowX:'auto'
  },

  filterBtn:{
    whiteSpace:'nowrap',
    border:'1px solid #ddd',
    borderRadius:16,
    padding:'6px 11px',
    background:'#fff',
    color:'#666',
    fontSize:12
  },

  filterActive:{
    borderColor:'#174a87',
    color:'#174a87',
    background:'#eef5ff'
  },

  reviewBtn:{
    marginLeft:'auto',
    whiteSpace:'nowrap',
    border:0,
    borderRadius:16,
    padding:'6px 11px',
    background:'#722ed1',
    color:'#fff',
    fontSize:12
  },

  resultBar:{
    color:'#999',
    fontSize:12,
    padding:'10px 4px 6px'
  },

  card:{
    background:'#fff',
    borderRadius:14,
    padding:'14px',
    marginBottom:10,
    boxShadow:'0 2px 9px rgba(0,0,0,.055)'
  },

  cardTop:{
    display:'flex',
    justifyContent:'space-between'
  },

  nameLine:{
    display:'flex',
    alignItems:'center',
    gap:7,
    flexWrap:'wrap'
  },

  name:{
    fontSize:18,
    fontWeight:800,
    color:'#222'
  },

  badge:{
    color:'#fff',
    padding:'2px 8px',
    borderRadius:5,
    fontSize:12
  },

  statusBadge:{
    fontSize:11,
    padding:'2px 7px',
    borderRadius:10
  },

  statusOk:{
    color:'#389e0d',
    background:'#f6ffed'
  },

  statusOff:{
    color:'#999',
    background:'#f3f3f3'
  },

  primaryInfo:{
    fontSize:14,
    color:'#333',
    marginTop:10,
    fontWeight:600
  },

  info:{
    fontSize:13,
    color:'#777',
    marginTop:5
  },

  verifyRow:{
    display:'flex',
    gap:8,
    marginTop:9,
    flexWrap:'wrap'
  },

  verifyOk:{
    fontSize:12,
    color:'#389e0d',
    background:'#f6ffed',
    border:'1px solid #b7eb8f',
    padding:'3px 8px',
    borderRadius:10
  },

  verifyBad:{
    fontSize:12,
    color:'#cf1322',
    background:'#fff1f0',
    border:'1px solid #ffa39e',
    padding:'3px 8px',
    borderRadius:10
  },

  actions:{
    display:'grid',
    gridTemplateColumns:'1.3fr 1fr 1fr',
    gap:7,
    marginTop:13
  },

  detailBtn:{
    height:36,
    border:0,
    borderRadius:7,
    background:'#174a87',
    color:'#fff',
    fontWeight:700
  },

  editBtn:{
    height:36,
    border:'1px solid #91caff',
    borderRadius:7,
    background:'#e6f4ff',
    color:'#0958d9'
  },

  toggleBtn:{
    height:36,
    border:'1px solid',
    borderRadius:7
  },

  empty:{
    textAlign:'center',
    padding:50,
    color:'#999'
  },

  modal:{
    position:'fixed',
    inset:0,
    background:'rgba(0,0,0,.48)',
    zIndex:300,
    display:'flex',
    alignItems:'flex-end',
    justifyContent:'center'
  },

  detailSheet:{
    width:'100%',
    maxWidth:760,
    maxHeight:'88vh',
    overflowY:'auto',
    background:'#fff',
    borderRadius:'18px 18px 0 0',
    padding:'20px',
    boxSizing:'border-box'
  },

  formSheet:{
    width:'100%',
    maxWidth:760,
    maxHeight:'88vh',
    overflowY:'auto',
    background:'#fff',
    borderRadius:'18px 18px 0 0',
    padding:'20px',
    boxSizing:'border-box'
  },

  sheetHead:{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'flex-start',
    borderBottom:'1px solid #eee',
    paddingBottom:14,
    marginBottom:12
  },

  sheetTitle:{
    fontSize:21,
    fontWeight:800,
    color:'#222'
  },

  sheetSub:{
    fontSize:12,
    color:'#888',
    marginTop:4
  },

  close:{
    width:34,
    height:34,
    border:0,
    borderRadius:17,
    background:'#f2f2f2',
    fontSize:23,
    color:'#666'
  },

  detailRow:{
    display:'grid',
    gridTemplateColumns:'90px 1fr',
    gap:10,
    padding:'10px 0',
    borderBottom:'1px solid #f2f2f2'
  },

  detailLabel:{
    color:'#888',
    fontSize:13
  },

  detailValue:{
    color:'#222',
    fontSize:14,
    wordBreak:'break-all'
  },

  sectionTitle:{
    marginTop:20,
    padding:'8px 10px',
    background:'#f3f7fc',
    borderLeft:'4px solid #174a87',
    fontWeight:800,
    color:'#174a87'
  },

  photoTitle:{
    fontSize:14,
    fontWeight:700,
    margin:'15px 0 8px'
  },

  photoLink:{
    display:'block',
    textDecoration:'none'
  },

  idPhoto:{
    display:'block',
    width:'100%',
    maxWidth:500,
    maxHeight:320,
    objectFit:'contain',
    background:'#f7f7f7',
    borderRadius:10,
    border:'1px solid #eee'
  },

  facePhoto:{
    display:'block',
    width:150,
    maxHeight:210,
    objectFit:'cover',
    borderRadius:10,
    border:'1px solid #eee'
  },

  openText:{
    marginTop:6,
    color:'#1677ff',
    fontSize:12
  },

  missing:{
    padding:18,
    background:'#fafafa',
    color:'#999',
    textAlign:'center',
    borderRadius:8
  },

  sheetEdit:{
    width:'100%',
    height:44,
    marginTop:20,
    border:0,
    borderRadius:9,
    background:'#174a87',
    color:'#fff',
    fontSize:15,
    fontWeight:800
  },

  input:{
    display:'block',
    width:'100%',
    padding:12,
    border:'1.5px solid #e0e0e0',
    borderRadius:8,
    fontSize:15,
    marginBottom:12,
    boxSizing:'border-box'
  },

  fieldLabel:{
    fontSize:13,
    color:'#555',
    fontWeight:700,
    margin:'2px 0 6px'
  },

  tip:{
    background:'#f6f0ff',
    color:'#65428a',
    border:'1px solid #e1d3f3',
    borderRadius:8,
    padding:'9px 10px',
    fontSize:12,
    lineHeight:1.55,
    margin:'-4px 0 12px'
  },

  modalBtns:{
    display:'flex',
    gap:12,
    marginTop:8
  },

  cancel:{
    flex:1,
    padding:12,
    border:'1px solid #ddd',
    borderRadius:8,
    background:'#fff',
    fontSize:15
  },

  confirm:{
    flex:1,
    padding:12,
    border:0,
    borderRadius:8,
    background:'#174a87',
    color:'#fff',
    fontSize:15,
    fontWeight:700
  }
};
